/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionClientsListMcpServers } from "../funcs/organizationRemoteSessionClientsListMcpServers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListOrganizationMcpServersResult } from "../models/components/listorganizationmcpserversresult.js";
import {
  ListOrganizationRemoteSessionClientMcpServersRequest,
  ListOrganizationRemoteSessionClientMcpServersSecurity,
} from "../models/operations/listorganizationremotesessionclientmcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationRemoteSessionClientMcpServersQueryData =
  ListOrganizationMcpServersResult;

export function prefetchOrganizationRemoteSessionClientMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientMcpServersRequest,
  security?: ListOrganizationRemoteSessionClientMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionClientMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationRemoteSessionClientMcpServersQuery(
  client$: GramCore,
  request: ListOrganizationRemoteSessionClientMcpServersRequest,
  security?: ListOrganizationRemoteSessionClientMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionClientMcpServersQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionClientMcpServers({
      clientId: request.clientId,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function organizationRemoteSessionClientMcpServersQueryFn(
      ctx,
    ): Promise<OrganizationRemoteSessionClientMcpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationRemoteSessionClientsListMcpServers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOrganizationRemoteSessionClientMcpServers(
  parameters: {
    clientId: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionClients",
    "listMcpServers",
    parameters,
  ];
}
